import { useEffect } from 'react';

/** The address fragment a notice email's "Choose which notices you get" link ends in, and the bell's own link. */
export const NOTICES_HASH = '#notices';

/**
 * Opens "Emails and notices" when the address asks for it: on arriving from an email's link, and when the
 * bell's link sets it. The fragment is taken off once used, so a reload or the next screen does not reopen it.
 */
export function useNoticesLink(open: () => void): void {
  useEffect(() => {
    const take = () => {
      if (window.location.hash !== NOTICES_HASH) return;
      window.history.replaceState(
        window.history.state,
        '',
        window.location.pathname + window.location.search,
      );
      open();
    };
    take();
    window.addEventListener('hashchange', take);
    return () => window.removeEventListener('hashchange', take);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `open` only sets state; one listener for the profile's life.
  }, []);
}
